import { AppBar, Box, Tab, Tabs } from "@mui/material";
import { ConfirmProvider } from "material-ui-confirm";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import AddClient from "../Client/Add";
import EditClient from "../Client/Edit";
import ClientList from "../Client/List";
import {
  CLIENTS_PATH,
  CLIENTS_URL,
  ENTRIES_PATH,
  ENTRIES_URL,
  FILTER_BY_CLIENT,
  GROUP_PATH,
  GROUP_URL,
  REPORT_PATH,
  REPORT_URL,
  TESTS_PATH,
  TESTS_URL,
} from "../constants";
import EntriesList from "../EntriesList";
import AddGroup from "../Group/Add";
import EditGroup from "../Group/Edit";
import GroupList from "../Group/List";
import AddReport from "../Report/Add";
import EditReport from "../Report/Edit";
import ReportList from "../Report/List";
import ClientSelector from "../Shared/ClientSelector";
import AddTest from "../Test/Add";
import DuplicateTest from "../Test/Duplicate";
import EditTest from "../Test/Edit";
import TestsList from "../Test/List";
import "./styles.scss";

function ProtectedArea() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(TESTS_URL);

  useEffect(() => {
    let { pathname } = location;

    if (pathname.includes(ENTRIES_URL)) {
      pathname = ENTRIES_URL;
    } else if (pathname.includes(REPORT_URL)) {
      pathname = REPORT_URL;
    } else if (pathname.includes(CLIENTS_URL)) {
      pathname = CLIENTS_URL;
    } else if (pathname.includes(GROUP_URL)) {
      pathname = GROUP_URL;
    } else {
      pathname = TESTS_URL;
    }

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setSelectedTab(pathname);
  }, [location]);

  function handleNavChange(event, tabUrl) {
    navigate(tabUrl);
    setSelectedTab(tabUrl);
  }

  return (
    <ConfirmProvider>
      <div className="page tool-page">
        <AppBar position="static">
          <Box display="flex" justifyContent="space-between">
            <Tabs
              value={selectedTab}
              onChange={handleNavChange}
              indicatorColor="secondary"
              textColor="inherit"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "@media (min-width: 1024px)": {
                  ".MuiTab-root": {
                    minWidth: 160,
                  },
                },
              }}
            >
              <Tab
                label={t("tool.general.header.tests", "Tests")}
                value={TESTS_URL}
              />
              <Tab
                label={t("tool.general.header.entries", "Entries")}
                value={ENTRIES_URL}
              />
              <Tab
                label={t("tool.general.header.reports", "Reports")}
                value={REPORT_URL}
              />
              <Tab
                label={t("tool.general.header.clients", "Clients")}
                value={CLIENTS_URL}
              />
              <Tab
                label={t("tool.general.header.groups", "Groups")}
                value={GROUP_URL}
              />
            </Tabs>
            {FILTER_BY_CLIENT[location.pathname] && (
              <Box mr="24px">
                <ClientSelector />
              </Box>
            )}
          </Box>
        </AppBar>
        <Routes>
          <Route path={TESTS_PATH} element={<TestsList />} />
          <Route path={`${TESTS_PATH}/new`} element={<AddTest />} />
          <Route path={`${TESTS_PATH}/:id`} element={<EditTest />} />
          <Route
            path={`${TESTS_PATH}/:id/duplicate`}
            element={<DuplicateTest />}
          />
          <Route path={`${ENTRIES_PATH}/*`} element={<EntriesList />} />

          <Route path={REPORT_PATH} element={<ReportList />} />
          <Route path={`${REPORT_PATH}/new`} element={<AddReport />} />
          <Route path={`${REPORT_PATH}/:id`} element={<EditReport />} />

          <Route path={GROUP_PATH} element={<GroupList />} />
          <Route path={`${GROUP_PATH}/new`} element={<AddGroup />} />
          <Route path={`${GROUP_PATH}/:id`} element={<EditGroup />} />

          <Route path={CLIENTS_PATH} element={<ClientList />} />
          <Route path={`${CLIENTS_PATH}/new`} element={<AddClient />} />
          <Route path={`${CLIENTS_PATH}/:id`} element={<EditClient />} />
          <Route index element={<Navigate to={TESTS_URL} replace />} />
        </Routes>
      </div>
    </ConfirmProvider>
  );
}

export default ProtectedArea;
